import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { processTimeline } from "./selectors"
import * as Actions from "./actions"
import * as ZillowMergeActions from "container/ZillowLeadMerge/actions"

function mapStateToProps(state) {
  const { client } = state
  return {
    ...client,
  }
}

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(
    {
      toggleZillowMergeModal: ZillowMergeActions.toggleZillowMergeModalAction.call,
    },
    dispatch
  ),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)
